import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

/**
 * Lesson format of a course subscription product (Produktkatalog). Missing on a product = GROUP (backward compatible).
 * The format of a course is derived from the subscription products of its active participants
 * (utils/helpers/lessonFormat.helper.ts).
 */
export enum LessonFormat {
    GROUP = 'group',
    DUO = 'duo',
    INDIVIDUAL = 'individual',
}

export namespace LessonFormat {
    export type Data = {
        /** Label in forms */
        text: string;
        /** Short label (chips) */
        short: string;
        /** Participants the format is sold for (group: undefined = setting / estimate) */
        expectedParticipants?: number;
    };

    export const Record: Record<LessonFormat, Data> = {
        [LessonFormat.GROUP]: {text: 'Gruppe', short: 'Gruppe'},
        [LessonFormat.DUO]: {text: 'Zu zweit', short: 'Zu zweit', expectedParticipants: 2},
        [LessonFormat.INDIVIDUAL]: {text: 'Einzelunterricht', short: 'Einzel', expectedParticipants: 1},
    };

    export const Items = mapRecordToItems(Record);
}
